<template>
  <div class="header_div">
    <!-- 固定头部-->
    <div class="ding">
      <div class="headertop">
        <!-- 左侧公司-->
        <img :src="list.company.logo" />
        <h3 class="conpanyname left">{{list.company.name}}<span class="slogan" v-if="list.company.slogan!='0'">{{list.company.slogan}}</span></h3>

        <!-- 右侧个人-->
        <div class="right">
          <el-dropdown class="center" style="width: 100%;">
            <span class="el-dropdown-link right">
              <div class="headimg left">
                <el-avatar :src="list.companyee.img"></el-avatar>
              </div>
              <div class="right" style="cursor: pointer;margin-top: 0.625rem;">
                  <i   class="el-icon-setting"></i>
              </div>
              <p class="headmsg right" style="cursor: pointer;">
                {{list.companyee.name}}<br />
                <span>普通用户</span>
              </p>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item><i class="el-icon-user"></i> 个人中心</el-dropdown-item>
              <el-dropdown-item>
              <i class="el-icon-notebook-2"></i> 我的笔记
              </el-dropdown-item>
              <el-dropdown-item ><i class="el-icon-star-off"></i> 我的收藏</el-dropdown-item>
              <!-- <el-dropdown-item><router-link to="/help"><i class="el-icon-reading"></i> 使用说明</router-link></el-dropdown-item> -->
              <el-dropdown-item>
                <span @click="logout()"><i class="el-icon-switch-button"></i> 返回登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <br />
          <!-- <el-button type="primary"  size="mini" round @click="goTo('/cindex?choice=chome')" v-if="info.type>0">我要管理 <span style="font-size: 0.05rem;">To manage</span></el-button> -->
          <el-button  type="danger" size="mini" round @click="goTo('/visitor_tasklist')">我的任务My Task</el-button>
        </div>

      </div>


      <!-- 导航栏-->

      <div class="headernav" >
        <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          background-color="#336397" text-color="#fff" active-text-color="#fff" menu-trigger="click"
          router :unique-opened="true" >
          <div v-for="(item,i) in get_lists" :key="i" style="display: inline;">
            <el-menu-item v-if="item.childs == 0"  :index="item.index"  style="display: inline; width: 100%;">
            <span v-if="item.name=='法规'&& new_data <'2022-11-26 00:00'" style="margin-left: -2.125rem;">
              <span style="position: relative;top:-1.1875rem;left: 3.75rem; color: red;">
                <img src="../../../assets/new.png" style="width: 1.875rem;z-index: 999;" />
              </span>
              {{item.name}}
            </span>
            <span v-else >{{item.name}}</span>

           <span v-if="item.ename=='Home'" style="position:absolute;margin-top: 1.2rem; margin-left: -2.25rem; font-size: 0.5rem;">{{item.ename}}</span>
           <span v-if="item.ename=='Task'" style="position:absolute;margin-top: 1.2rem; margin-left: -3rem; font-size: 0.5rem;">{{item.ename}}</span>
           <span v-if="item.ename=='Eval'" style="position:absolute;margin-top: 1.2rem; margin-left: -3rem; font-size: 0.5rem;">{{item.ename}}</span>
           <span v-if="item.ename=='Doc.'" style="position:absolute;margin-top: 1.2rem; margin-left: -2.8rem; font-size: 0.5rem;">{{item.ename}}</span>
            </el-menu-item>
            <el-submenu v-if="item.childs == 1" :index="item.index"  style="display: inline;">
              <template slot="title" style="display: inline; ">
                <!-- <span v-if="item.name=='测评'|| item.name=='法规' && new_data <'2022-11-26 00:00'" style="margin-right: 0.8125rem; margin-left: -2.125rem;" >
                    <span style="position: relative;top:-1.1875rem;left: 3.75rem; color: red;" >
                      <img  src="../../../assets/new.png" style="width: 1.875rem;z-index: 999;" />
                  </span>
                {{item.name}}</span>
                <span v-else style="margin-right: 0.8125rem;">{{item.name}}</span> -->


                <span v-if="(item.name=='测评' || item.name=='法规') &&new_data <'2022-12-26 00:00'" style="margin-right: 0.8125rem; margin-left: -2.125rem;" >
                    <span style="position: relative;top:-1.1875rem;left: 3.75rem; color: red;" >
                      <img  src="../../../assets/new.png" style="width: 1.875rem;z-index: 999;" />
                  </span>
                {{item.name}}</span>
                <span v-else-if="(item.name=='测评' || item.name=='法规') && new_data >'2022-12-26 00:00'" style="margin-right: 0.8125rem;" >
                {{item.name}}</span>
                <span v-else style="margin-right: 0.8125rem;">{{item.name}}</span>
              <span v-if="item.ename=='Course'" style="position:absolute;margin-top: 1.2rem; margin-left: -3rem; font-size: 0.5rem;">{{item.ename}}</span>
              <span v-if="item.ename=='Live'" style="position:absolute;margin-top: 1.2rem; margin-left: -2.8rem; font-size: 0.5rem;">{{item.ename}}</span>
              <span v-if="item.ename=='Support'" style="position:absolute;margin-top: 1.2rem; margin-left: -3.7rem; font-size: 0.5rem;">{{item.ename}}</span>
            </template>

              <el-menu-item v-for="(items,is) in item.child" :key="is" :index="items.index">{{items.name}}</el-menu-item>
            </el-submenu>
           </div>
          <!-- <span style="color: #FFFFFF; cursor: pointer; font-size: 14px;" @click="problem_cilck()"><span>需求/反馈</span>
          <span  style="position:absolute;margin-top: 2.4rem; margin-left: -3.7rem; font-size: 0.5rem;"></span> -->
          </span>
        </el-menu>
      </div>
    </div>
    <!-- 占位-->
    <div class="zhan">
      <el-dialog title=需求/反馈 :visible.sync="problem.show">
        <el-dropdown  style="margin-bottom: 10px;">
          <span class="el-dropdown-link1111">
            {{problem.dropdown}}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" @click="handleClick">
            <el-dropdown-item @click.native="handleClick('课程需求')">课程需求</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('系统问题')">系统问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('视频问题')">视频问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('文档问题')">文档问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('任务问题')">任务问题</el-dropdown-item>
            <el-dropdown-item @click.native="handleClick('其他')">其他</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-input  type="textarea" :rows="3" v-model="problem.input" placeholder="请详细描述"></el-input>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="feedback()">确 定</el-button>
            <el-button @click="problem.show = false " >取 消</el-button>
          </div>
      </el-dialog>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        list:{
          company:{
            logo:'',

          },
          companyee:{
            img:''
          }
        },
        new_data:'',
        problem:{
          input:'',
          show:false,
          dropdown :'需求/反馈类型',
        },
        info:this.$store.state.info,
        activeIndex: '1',
        get_lists:[
          {index:"visitor_home",name:"首页",ename:'',childs:0},
          {index:"visitor_tasklist",name:"任务",ename:'',child:[],childs:0},
          {index:"3",name:"药知",ename:'',child:[
            {index:"visitor_Opencourses_tow?type=0",name:"课程",},
            {index:"visitor_livebroadcast",name:"直播",},
            {index:"visitor_question",name:"答疑",},
          ],childs:1 },
          {index:"4",name:"内部",ename:'',child:[
            {index:"visitor_opencourses?type=1",name:"视频",},
            {index:"visitor_Filetow?num=0",name:"文档",},
          ],childs:1 },
          {index:"8",name:"法规",ename:'',child:[
            {index:"visitor_statute",name:"在线查看",},
            {index:"visitor_statute_map?num=",name:"地图链接",},
            {index:"visitor_Official_account_list",name:"最新",},
          ],childs:1 },
          {index:"6",name:"测评",ename:'',childs:0},
          {index:"7",name:"说明/帮助",ename:'',child:[
            {index:'#rzex',name:'睿知而行官网'},
            {index:'#help',name:'使用说明'},
            // {index:'#problem',name:'需求/反馈'},
            {index:"visitor_customizedcourses",name:"定制",},
            {index:'client_download',name:'客户端下载'},
          ],childs:1},
        ],
        traincount_status:'',
        traincount_status_show:'',
        traincount_status_showt:'',
      };
    },
    mounted:function(){
      this.new_data_click()
      this.get_info()
    },
    methods: {
      get_info(){
        let _this = this;
          _this.axios
        .get("/v2/temp/header_info")
        .then(function (res) {
          if (res.status == "200") {
            if (res.data.code == "1") {
              _this.list=res.data.data
            }
          }
        })
      },
      new_data_click(){
        let yy = new Date().getFullYear();
        　　let mm = new Date().getMonth()+1;
        　　let dd = new Date().getDate();
        　　let hh = new Date().getHours();
        　　let mf = new Date().getMinutes()<10 ? '0'+new Date().getMinutes() : new Date().getMinutes();
            if (mm < 10) mm = "0" + mm;
            if (dd < 10) dd = "0" + dd;
            if (hh < 10) hh = "0" + hh;
            if (mf < 10) mf = "0" + mf;
        　　 this.new_data = yy+'-'+mm+'-'+dd+' '+hh+':'+mf;
      },
      handleClick(type){
        this.problem.dropdown=type
      },

      // feedback(){
      //   let _this=this
      //   var data={
      //     'type':_this.problem.dropdown,
      //     'content':_this.problem.input
      //   }
      //   if(data.type=='需求/反馈类型'){
      //     _this.$message.error('请选择需求/反馈类型')
      //     return false
      //   }
      //   if(data.content==''){
      //     _this.$message.error('描述内容不能为空')
      //     return false
      //   }
      //   _this.axios.post('/v2/user/feedback_save', {
      //     data: data //注意post请求发送参数的方式和get请求方式是有区别的
      //   }).then(function(res) {
      //     if(res.status=='200'){
      //       if(res.data.code=='1'){
      //        _this.$message.success(res.data.msg)
      //        _this.problem.show=false
      //        _this.problem.input=''
      //        _this.problem.dropdown='需求/反馈类型'
      //       }else{
      //         _this.$message.error(res.data.msg)
      //       }
      //     }else{
      //       _this.$message.error('服务器内部错误')
      //     }
      //   }).catch(function(error) {
      //     _this.$message.error('服务器内部错误')
      //   })
      // },
      problem_cilck(){
        this.problem.show=true
      },
      //
      // handleSelect(key, keyPath) {
      //   if(keyPath[0]==5 && keyPath[1]==""){
      //     this.goPage('https://appy50vdxnm5900.h5.xiaoeknow.com/')
      //   }
      //   if(keyPath[0]==6 && keyPath[1]==''){
      //    // this.goPage('https://ruizhierxing.com')
      //   }
      // },

      handleSelect(key, keyPath) {
        var s=window.location.href;
        s=s.replace(/keyPath[1]/g, ''); // \:转义符
        // if(keyPath[0]==5 && keyPath[1]==""){
        //   this.goPage('https://appy50vdxnm5900.h5.xiaoeknow.com/')
        // }
        console.log(s)
        if(keyPath[0]==6){
          this.check_power(s)
          // this.$message('更多功能，请联系王老师:13260265598(手机号同微信)')

        }
        if(keyPath[0]==7 && keyPath[1]=='#rzex'){
         this.goPage('https://ruizhierxing.com')
         window.location.href=s
        }
        if(keyPath[0]==7 && keyPath[1]=='#problem'){
          this.problem_cilck()
        }
        if(keyPath[0]==7 && keyPath[1]=='#help'){
         this.goPage('https://api.zhiyaozhishi.com/mind/handbook.html')
         window.location.href=s
        }
      },

      // 跳转页面方法
      /* 新标签页*/
      goPage(url) {
        window.open(url, '_blank')
      },
      /* 原页面 */
      goTo(url) {
        this.$router.push(url)
      },

      check_power(s){
        let _this=this
       window.open('http://evaluate.zhiyaozhishi.com', '_blank')
       window.location.href=s
       // _this.goTo('visitor_home')
       // _this.$router.push({path:'../../../view/visitor/Home'})
        // _this.axios.post("/v2/user/check_evaluate").then(function (res) {
        //   if(res.data.code=='1'){
        //     if(res.data.hasOwnProperty('data') && res.data.data.hasOwnProperty('href')){
        //       _this.goPage(res.data.data.href)
        //       window.location.href=s
        //     }
        //   }else{
        //     _this.$message.error(res.data.msg)
        //   }
        // })
      },

      logout(){
        let _this=this
        this.$router.push({
          path: '/login', // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      //   localStorage.setItem('authorization', '')
      //   this.$store.commit('info_save', null)
      //   setTimeout(()=>{
      //     _this.$notify({
      //       title: '成功退出',
      //       type: 'success'
      //     });
      //     this.$router.push({
      //       path: '/login',
      //       query: {redirect: this.$route.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      //     });
      //   },1000)

      },
    },
  }
</script>

<style scoped>
   .el-dropdown-link1111 {
      cursor: pointer;
      color: #409EFF;
    }
    .el-icon-arrow-down {
      font-size: 12px;
    }
>>>.el-submenu__title {
    font-size: 14px;
    color: #303133;
    padding: 0 20px;
    cursor: pointer;
    -webkit-transition: border-color .3s,background-color .3s,color .3s;
    transition: border-color .3s,background-color .3s,color .3s;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline;
}
  .header_div {
    height: 150px;
    background-color: white;
    z-index: 999;
  }

  .ding {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .zhan {
    height: 150px;
  }

  .headertop {
    background-color: white;
    height: 90px;
    width: 70%;
    padding: 0 15%;
  }

   .headertop img {
      width: 6.25rem;
      height: 3.125rem;
      padding: 20px;
      float: left;
    }

  .slogan {
    padding-left: 20px;
    font-size: 15px;
  }

  .conpanyname {
    margin: 0;
    padding: 20px;
  }

  .headimg,
  .headmsg {
    margin: 5px;
  }

  .el-menu-demo {
    width: 70%;
    padding: 0 16%;
  }

  >>>.el-menu {
    margin: 0;
    width: 100%;
    border: 0;
  }


  router-link:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  router-link:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  router-link:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  router-link:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }

  a:link {
    text-decoration: none;
    color: #606266;
    /* 指正常的未被访问过的链接*/
  }

  a:visited {
    text-decoration: none;
    color: #606266;
    /*指已经访问过的链接*/
  }

  a:hover {
    text-decoration: none;
    color: #66B1FF;
    /*指鼠标在链接*/
  }

  a:active {
    text-decoration: none;
    color: #66B1FF;
    /* 指正在点的链接*/
  }


</style>



// WEBPACK FOOTER //
// src/components/index/public/visitor_NavHeader.vue